module.exports = __webpack_public_path__ + "static/media/notificationError.0a7a78fb.svg";